export enum DataTypes {
  ADDRESS = 'ADDRESS',
  INSTITUTE = 'INSTITUTE',
  OBJECT = 'OBJECT',
}
